import { logger } from "../../helpers/logger.qwik.mjs";
import { get } from "../get.qwik.mjs";
import { chooseBrowserOrServerEval } from "./choose-eval.qwik.mjs";
import { parseCode, getBuilderGlobals } from "./helpers.qwik.mjs";
const STATE_GETTER_REGEX = /^(return )?(\s*)?state(?<getPath>(\.\w+)+)(\s*);?$/;
const VIRTUAL_INDEX_REGEX = /(\s)*var(\s)+_virtual_index(\s)*=(\s)*state(?<getPath>(\.\w+)+)(\s*);?(\s)*return(\s)*_virtual_index(\s)*/;
const getSimpleExpressionGetPath = (code) => {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = STATE_GETTER_REGEX.exec(code.trim())) == null ? void 0 : _a.groups) == null ? void 0 : _b.getPath) == null ? void 0 : _c.slice(1)) || ((_f = (_e = (_d = VIRTUAL_INDEX_REGEX.exec(code.trim())) == null ? void 0 : _d.groups) == null ? void 0 : _e.getPath) == null ? void 0 : _f.slice(1));
};
function evaluate({ code, context, localState, rootState, rootSetState, event, isExpression = true }) {
  if (code.trim() === "")
    return void 0;
  const getPath = getSimpleExpressionGetPath(code.trim());
  if (getPath)
    return get({
      ...rootState,
      ...localState
    }, getPath);
  const args = {
    code: parseCode(code, {
      isExpression
    }),
    builder: getBuilderGlobals(),
    context,
    event,
    rootSetState,
    rootState,
    localState
  };
  try {
    const newEval = chooseBrowserOrServerEval(args);
    return newEval;
  } catch (e) {
    logger.error("Failed code evaluation: " + e.message, {
      code
    });
    return void 0;
  }
}
export {
  evaluate,
  getSimpleExpressionGetPath
};
